import React from 'react'
import { useSelector} from 'react-redux'
import { useLocation } from 'react-router-dom'
import demoImg from '../../assets/cities/temp.png'

const Header = () => {
  const { headerImage } = useSelector((state) => state.headerImage);
  const location = useLocation();
  
  // Use corporate.png for Business/Corporate page
  const isBusinessPage = location.pathname === '/corporate';
  const headerImgSrc = isBusinessPage ? '/images/header/corporate.png' : demoImg;
  
  return (
    <header className='header'>
        {/* <img  src={headerImage?.images?headerImage?.images:'/images/header-image-larger.png'} alt='Pulpit cab service - Taxi cab running on road for reliable transportation' className='header__image'></img> */}
        <img  src={headerImgSrc} alt='Pulpit cab service - Taxi cab running on road for reliable transportation' className='header__image fit '></img>
    </header>
  )
}

export default Header